import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { isLoggedIn } from '../../utils/auth';

const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4613/auth';

export const agentsApi = createApi({
  reducerPath: 'agentsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token && isLoggedIn()) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  keepUnusedDataFor: 0,
  tagTypes: ['Agents'],
  endpoints: (builder) => ({
    getAgents: builder.query({
      query: (params = {}) => ({
        url: '/agents',
        method: 'GET',
        params: {
          page: params.page,
          limit: params.limit,
          search: params.search,
        }
      }),
      providesTags: ['Agents'],
    }),
    
    getAgent: builder.query({
      query: (agentId) => `/agents/${agentId}`,
      providesTags: (result, error, agentId) => [{ type: 'Agents', id: agentId }],
    }),
    
    createAgent: builder.mutation({
      query: (agentData) => ({
        url: '/agents',
        method: 'POST',
        body: agentData,
      }),
      invalidatesTags: ['Agents'],
    }),
    
    updateAgent: builder.mutation({
      query: ({ id, ...agentData }) => ({
        url: `/agents/${id}`,
        method: 'PUT',
        body: agentData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Agents', id },
        'Agents'
      ],
    }),
    
    deleteAgent: builder.mutation({
      query: (agentId) => ({
        url: `/agents/${agentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Agents'],
    }),
  }),
});

export const {
  useGetAgentsQuery,
  useGetAgentQuery,
  useCreateAgentMutation,
  useUpdateAgentMutation,
  useDeleteAgentMutation,
} = agentsApi; 